import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SeoMeta from "@/components/SeoMeta";
import { motion } from "framer-motion";
import { Shield, Lock, FileText, UserCheck, Mail } from "lucide-react";

const LOGO_URL = "https://media.base44.com/images/public/6a5d15c6e07267225235d487/319d7a07e_logo.jpg";

const sections = [
  {
    icon: FileText,
    title: "1. Introducción",
    content: `Servicios Aéreos GBIC®, división de GBIC Comunicaciones®, con domicilio en Sierra Nevada 325 B, Col. Lomas del Tecnológico, Morelia, Michoacán, México, CP 58117, es responsable del tratamiento de sus datos personales y de la protección de su privacidad, conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) y su Reglamento.

La presente Política de Privacidad describe cómo recopilamos, utilizamos, almacenamos y protegemos los datos personales que usted nos proporciona al utilizar nuestro sitio web y contratar nuestros servicios aéreos.`
  },
  {
    icon: UserCheck,
    title: "2. Datos Personales Recabados",
    content: `Recabamos los siguientes datos personales, necesarios para la prestación de nuestros servicios aéreos:

Datos de identificación:
• Nombre completo
• Nacionalidad
• Fecha de nacimiento (para vuelos)

Datos de contacto:
• Teléfono fijo y móvil
• Correo electrónico
• Domicilio

Datos operacionales:
• Información de vuelo (origen, destino, fecha, hora)
• Datos de pasajeros y carga
• Información médica (para servicios de ambulancia aérea)
• Documentación de identidad (para cumplimiento de la AFAC)

Datos de pago:
• Datos de facturación
• Comprobantes de pago

No recabamos datos personales sensibles, salvo en el caso de información médica necesaria para servicios de ambulancia aérea, la cual se trata con estricta confidencialidad.`
  },
  {
    icon: FileText,
    title: "3. Finalidades del Tratamiento",
    content: `Sus datos personales serán utilizados para las siguientes finalidades primarias, necesarias para la prestación del servicio:

• Gestión y confirmación de reservas de vuelo
• Coordinación operacional de servicios aéreos
• Facturación y cobranza
• Cumplimiento de obligaciones ante la Agencia Federal de Aviación Civil (AFAC)
• Atención de emergencias y servicios médicos (ambulancia aérea)
• Verificación de identidad y seguridad

Finalidades secundarias (opcionales, puede oponerse):
• Envío de promociones y ofertas de servicios
• Estadísticas y mejoras de servicio
• Comunicación sobre nuevos servicios
• Estudios de mercado

Si no desea que sus datos sean utilizados para las finalidades secundarias, puede enviar su solicitud de exclusión a través de los medios de contacto indicados en esta política.`
  },
  {
    icon: Lock,
    title: "4. Medidas de Seguridad",
    content: `Servicios Aéreos GBIC® implementa medidas técnicas, administrativas y físicas para proteger sus datos personales contra acceso no autorizado, alteración, divulgación o destrucción:

• Cifrado de datos en tránsito y reposo
• Acceso restringido a personal autorizado y capacitado
• Sistemas de monitoreo de seguridad
• Respaldo periódico de información
• Protocolos de respuesta a incidentes

A pesar de estas medidas, ningún sistema es completamente seguro, por lo que no podemos garantizar la seguridad absoluta de la información transmitida a través de internet.`
  },
  {
    icon: Shield,
    title: "5. Compartición de Datos",
    content: `No vendemos, rentamos ni comercializamos sus datos personales con terceros. Compartimos su información únicamente en los siguientes casos:

• Autoridades aeronáuticas y gubernamentales (AFAC, SCT) cuando sea requerido por ley
• Proveedores de servicios directamente involucrados en la operación (torres de control, aeródromos, proveedores de combustible)
• Compañías de seguro para la gestión de pólizas y siniestros
• Autoridades sanitarias (en servicios de ambulancia aérea)
• Cuando sea necesario para cumplir con obligaciones legales o requerimientos de autoridades competentes

Los terceros que reciben sus datos están obligados a mantener la confidencialidad y protección de los mismos conforme a la legislación aplicable.`
  },
  {
    icon: FileText,
    title: "6. Conservación de Datos",
    content: `Conservamos sus datos personales durante el tiempo necesario para cumplir con las finalidades descritas, así como para cumplir con las obligaciones legales aplicables a la industria aeronáutica:

• Registros de vuelo y operación: 5 años conforme a normativa AFAC
• Información fiscal y de pago: 5 años conforme al Código Fiscal de la Federación
• Datos de contacto y reservas: 3 años tras la última interacción
• Datos médicos (ambulancia aérea): 5 años conforme a normativas sanitarias

Transcurridos estos períodos, los datos serán eliminados de forma segura.`
  },
  {
    icon: Shield,
    title: "7. Derechos ARCO",
    content: `Usted tiene derecho a ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición (Derechos ARCO), así como el derecho a la revocación del consentimiento:

• Acceso: Conocer qué datos personales tenemos de usted
• Rectificación: Solicitar la corrección de datos inexactos o incompletos
• Cancelación: Solicitar la eliminación de sus datos
• Oposición: Oponerse al tratamiento de sus datos para fines específicos
• Revocación del consentimiento: Retirar su autorización para el tratamiento

Para ejercer estos derechos, deberá presentar su solicitud a través de los medios de contacto indicados, incluyendo:
• Nombre completo
• Correo electrónico o teléfono
• Descripción clara del derecho que desea ejercer
• Documentación que respalde su solicitud

Atenderemos su solicitud en un plazo máximo de 20 días hábiles, conforme a la LFPDPPP.`
  },
  {
    icon: Lock,
    title: "8. Cookies y Tecnologías Similares",
    content: `Nuestro sitio web utiliza cookies y tecnologías similares para mejorar su experiencia de navegación:

• Cookies técnicas: necesarias para el funcionamiento del sitio
• Cookies de análisis: nos ayudan a entender cómo utiliza el sitio
• Cookies de preferencias: recuerdan sus configuraciones

Puede configurar su navegador para rechazar cookies, aunque algunas funcionalidades del sitio podrían no operar correctamente.`
  },
  {
    icon: FileText,
    title: "9. Transferencias Internacionales",
    content: `Dado que nuestras operaciones aéreas abarcan México, Estados Unidos y Centroamérica, sus datos personales podrán ser transferidos a destinatarios ubicados en estos países, únicamente para los fines operacionales necesarios.

Estas transferencias se realizan bajo las salvaguardas adecuadas y conforme a la legislación aplicable, asegurando que sus datos reciban un nivel adecuado de protección en el extranjero.`
  },
  {
    icon: FileText,
    title: "10. Cambios a esta Política",
    content: `Servicios Aéreos GBIC® se reserva el derecho de modificar la presente Política de Privacidad en cualquier momento. Las modificaciones serán publicadas en este sitio y entrarán en vigor al momento de su publicación.

Le recomendamos revisar periódicamente esta política para mantenerse informado sobre cómo protegemos sus datos personales.`
  }
];

export default function Privacy() {
  return (
    <div className="bg-nocturnal min-h-screen">
      <SeoMeta
        title="Política de Privacidad | Servicios Aéreos GBIC®"
        description="Política de privacidad y protección de datos personales de Servicios Aéreos GBIC® conforme a la LFPDPPP. Datos recabados, finalidades del tratamiento, medidas de seguridad y derechos ARCO."
        path="/privacidad"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Política de Privacidad", path: "/privacidad" }]}
      />
      <Navbar />
      <section className="relative pt-32 sm:pt-40 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F3A] via-[#06142A] to-[#0A1F3A]" />
        <div className="absolute top-20 left-0 w-[500px] h-[500px] bg-ochre/5 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-12"
          >
            <div className="flex items-center justify-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Servicios Aéreos GBIC" className="w-14 h-14 rounded-full object-cover ring-2 ring-[#F97316]/40" />
              <div className="text-left leading-tight">
                <span className="block font-heading font-bold text-sm tracking-wider text-white">SERVICIOS AÉREOS</span>
                <span className="block text-ochre font-heading text-[10px] tracking-[0.2em] font-semibold">GBIC&reg;</span>
              </div>
            </div>
            <h1 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white tracking-tight mb-4">
              Política de <span className="text-ochre">Privacidad</span>
            </h1>
            <p className="text-cirrus text-sm tracking-wide max-w-xl mx-auto">
              Protección y tratamiento de datos personales conforme a la LFPDPPP.
            </p>
            <p className="text-white/30 text-xs font-mono tracking-wider mt-4">
              Última actualización: Julio 2026
            </p>
          </motion.div>

          <div className="space-y-6">
            {sections.map((section, i) => {
              const Icon = section.icon;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.05 }}
                  className="glass-panel rounded-lg p-6 sm:p-8"
                >
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 rounded-lg bg-ochre/20 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-5 h-5 text-ochre" />
                    </div>
                    <h2 className="font-heading font-bold text-white text-lg sm:text-xl tracking-wide leading-snug pt-1.5">
                      {section.title}
                    </h2>
                  </div>
                  <div className="text-white/60 text-sm sm:text-base leading-relaxed tracking-wide whitespace-pre-line pl-0 sm:pl-14">
                    {section.content}
                  </div>
                </motion.div>
              );
            })}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="glass-panel rounded-lg p-6 sm:p-8 mt-8 text-center"
          >
            <Mail className="w-8 h-8 text-ochre mx-auto mb-3" />
            <h3 className="font-heading font-bold text-white text-lg tracking-wide mb-2">Ejercer sus derechos ARCO</h3>
            <p className="text-white/60 text-sm tracking-wide mb-4">
              Contáctenos para acceder, rectificar, cancelar u oponerse al tratamiento de sus datos personales.
            </p>
            <a
              href="/#contacto"
              className="inline-flex items-center gap-2 bg-ochre text-white font-heading font-bold text-sm tracking-wider uppercase px-6 py-3 rounded-lg hover:bg-[#EA580C] transition-all"
            >
              Contactar
            </a>
          </motion.div>
        </div>
      </section>
      <Footer />
    </div>
  );
}